export const titleOverflowDirective = {
  mounted(el: any) {
    const checkEllipsis = () => {
      // Safely check if the element exists and has width boundaries
      if (el && el.scrollWidth > el.clientWidth) {
        el.setAttribute('title', el.textContent.trim());
      } else if (el) {
        el.removeAttribute('title');
      }
    };

    // Initial check after DOM insertion
    checkEllipsis();

    // Use ResizeObserver to dynamically add/remove the title if the screen or element resizes
    el._resizeObserver = new ResizeObserver(() => checkEllipsis());
    el._resizeObserver.observe(el);

    // MutationObserver handles dynamic text changes inside the tag (e.g. v-if or variable changes)
    el._mutationObserver = new MutationObserver(() => checkEllipsis());
    el._mutationObserver.observe(el, { childList: true, characterData: true, subtree: true });
  },

  unmounted(el) {
    // Prevent memory leaks by cleaning up observers
    if (el._resizeObserver) {
      el._resizeObserver.disconnect();
    }
    if (el._mutationObserver) {
      el._mutationObserver.disconnect();
    }
  }
};